import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { GoldenLayoutAdditionMode } from "../../golden-layout/golden-layout-addition-mode";
import { DashboardItemType } from "../../bfx-common/models/dashboard-item-type.enum";
import {
  GoldenLayoutService,
  GLPopoutConfiguration,
  GLPopoutState,
  GLPopoutUndockBehaviour,
} from "../../golden-layout/golden-layout-service";
import { LoggerService } from "@bfx/logger";
import { DETAILS_MIN_SIZE } from "shared/cubiq-services/model/golden-layout.constants";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxDealDetailsService {
  constructor(protected layoutService: GoldenLayoutService) {}

  openDeal(dealId: string, event: Event) {
    let config: GLPopoutConfiguration = new GLPopoutConfiguration();

    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = false;
    config.data = { tradeDealId: dealId };
    config.sourceEvent = event;
    config.minimumSize = DETAILS_MIN_SIZE;

    let title: string = "Trade Details"; // temp, will be replaced in component when deal is loaded
    this.layoutService.launchFromDashboard(
      title,
      DashboardItemType.DealDetails,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }
}
